import moment from "moment";

export function formatRelativeTime(date) {
  if (!date) return "";

  const target = moment(date);
  if (!target.isValid()) return "";

  const now = moment();
  const diffSeconds = now.diff(target, "seconds");
  const diffMinutes = now.diff(target, "minutes");
  const diffHours = now.diff(target, "hours");
  const diffDays = now.diff(target, "days");

  if (diffSeconds < 60) return "Just now";
  if (diffMinutes < 60)
    return `${diffMinutes} minute${diffMinutes === 1 ? "" : "s"} ago`;
  if (diffHours < 24)
    return `${diffHours} hour${diffHours === 1 ? "" : "s"} ago`;
  if (diffDays === 1) return "Yesterday";
  if (diffDays < 7) return `${diffDays} days ago`;

  return target.format("DD MMM YYYY");
}
